import { api } from "./api";

export const getRoleList = async (addUrl = "") => {
  return await api.get(`roles?${addUrl}`);
};

export const getManagementList = async (addUrl = "") => {
  return await api.get(`managements?${addUrl}`);
};

export const AddRole = async (data) => {
  return await api.post(`role/add`, data);
};

export const UpdateRole = async (data) => {
  return await api.post(`role/update`, data);
};

export const DeleteRole = async (id) => {
  return await api.post(`role/delete`, { id });
};

export const RoleDetails = async (id) => {
  return await api.get(`role/details?id=${id}`);
};

export const UpdateRolePermissions = (roleId, routeIds) => {
  return api.post("/role-permissions-update", {
    id: Number(roleId),
    route_ids: routeIds.map(Number),
  });
};

export const CreateClientRole = (name) =>
  api.post('/role-create', { name });

export const UpdateClientRole = (id, name) =>
  api.post('/role-update', { id, name });

export const appRoleList = async (addUrl = "") => {
  return await api.get(`/role/app/list?${addUrl}`);
};

export const assignRoleToStaff = async (data) => {
  return await api.post(`assign/role/to/staff`, data);
};

export const staffListWithNoRole = async (data) => {
  return await api.post(`staff/with/no/role`, data);
};
